export const BASE_COLOR = "#008B52"
export const dateFormatList = ["DD/MM/YYYY"];
export const LOGIN_PATH = "/admin/login"
